export default "__VITE_ASSET__e6e4f645__"